import { atom } from "recoil"

export type ModalityTimeRow = {
	variable: string
	min_start_time: number
	max_end_time: number
}

export type ModalityTimesByPatient = Record<number, ModalityTimeRow[]>

export const modalityTimesAtom = atom<ModalityTimesByPatient>({
	key: "modalityTimes",
	default: {},
})
